/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  AuthorizationsListResponse,
  DownloadAuthorizationResult,
  FetchAuthorizationsPayload,
} from './types';
import { apiClient } from '@/utils/apiClient';
import { toQS } from '@/utils/toQS';

export const fetchAuthorizations = createAsyncThunk<
  AuthorizationsListResponse,
  FetchAuthorizationsPayload | undefined,
  { rejectValue: string }
>('workflows/authorizations/fetch', async (payload, { rejectWithValue }) => {
  try {
    const qs = toQS(payload);
    const res = await apiClient(`/workflows/api/v1/authorizations/${qs}`, {
      method: 'GET',
    });
    return res as AuthorizationsListResponse;
  } catch (err: any) {
    const r: any = err?.response ?? err;
    const msg =
      (Array.isArray(r?.error) && r.error.join(' ')) ||
      r?.error ||
      r?.message ||
      'Failed to load licenses/permits';
    return rejectWithValue(String(msg));
  }
});
export const downloadAuthorizationFile = createAsyncThunk<
  DownloadAuthorizationResult,
  { number: string },
  { rejectValue: string }
>(
  'payments/authorizations/downloadFile',
  async ({ number }, { rejectWithValue }) => {
    if (!number) return rejectWithValue('License/permit number is required');

    try {
      const response = await apiClient(
        `/workflows/api/v1/authorizations/${encodeURIComponent(
          number
        )}/download/`,
        {
          method: 'GET',
        }
      );

      const data = response as any;

      if (data?.file_url) {
        return {
          file_url: data.file_url,
          number: data.number,
          created_at: data.created_at,
          id: data.id,
        };
      }

      return rejectWithValue('No file URL found in license/permit response');
    } catch (err: any) {
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        'Failed to download license/permit file';
      return rejectWithValue(msg);
    }
  }
);
